import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { AdmissionBinderComponent } from './admission-binder.component';
import { getAdmissionCategoryById } from 'shared/store/selectors/admission.selector';
import { admissionSelectChecklist } from 'src/store/actions/admission-viewer.actions';
import {
  updateChecksOrder,
  createQuickCheckListItem,
} from 'shared/store/actions/admission.actions';
import { INTERNAL_ROUTING } from 'shared/constants';

const mapStateToProps = ({ admission, application, owners, lang }, ownProps) => {
  const { id } = ownProps;

  const category = id ? getAdmissionCategoryById(admission, { id }) : {};

  return {
    id,
    category,
    adminMode: application.adminMode,
    lastUpdated: admission.lastUpdated,
    langPage: lang.ADMISSION_CHECKLIST_PAGE,
    langButtons: lang.CHECKLIST_BUTTONS,
    langTooltip: lang.ACTION_BUTTON_TOOLTIPS,
    isHaveActiveChecklist: Object.keys(admission.activeChecklist).length > 0,
  };
};

const mapDispatchToProps = {
  admissionSelectChecklist,
  updateOrder: updateChecksOrder,
  createQuickCheckListItem,
};

const ConnectedAdmissionBinder = connect(
  mapStateToProps,
  mapDispatchToProps,
)(AdmissionBinderComponent);

export const AdmissionBinder = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const id = searchParams.get(INTERNAL_ROUTING.QUERY_PARAMS.CHECKLIST);

  return <ConnectedAdmissionBinder id={id} />;
};
